import { TItemListProps } from '@@types/list';

export default function ItemList<T extends Record<string, any>>({
  items,
  renderer,
  emptyMessage,
}: TItemListProps<T>) {
  return (
    <>
      {items.length > 0
        ? items.map((item, index) => renderer(item, index))
        : emptyMessage ?? <></>}
    </>
  );
}
